import type { IssueStatus } from '../types/issue';
import type { ClosureEvaluation } from './efficacyCheck';

/**
 * Encerrar no Problema Estruturado exige o estado `monitoring`, o caso B do P4
 * e a prontidão da padronização. A máquina continua permitindo
 * `validation → closed` e `monitoring → closed` sem esses itens.
 * O botão não dispara sozinho. Caso C segue o motivo já exigido pelo P4.
 */
export function conclusionAllowsClose(input: {
  status: IssueStatus;
  closure: Pick<ClosureEvaluation, 'canClose' | 'case'>;
  standardizationReady: boolean;
  transitionAllowed: boolean;
}): boolean {
  return input.status === 'monitoring'
    && input.closure.case === 'B'
    && input.closure.canClose
    && input.standardizationReady
    && input.transitionAllowed;
}

/** Só existe quando as duas datas reais estão presentes. Não projeta prazo. */
export function conclusionDurationDays(
  createdAt: string | null | undefined,
  resolvedAt: string | null | undefined,
): number | null {
  if (!createdAt || !resolvedAt) return null;
  const start = Date.parse(createdAt);
  const end = Date.parse(resolvedAt);
  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) return null;
  return Math.round((end - start) / 86_400_000);
}
